import { useTheme } from 'styled-components';
import { getToken } from '@optimus-web/common';
import { ProductLogoSvg } from './style';
import { MewsLogoSize } from './types';

interface ProductLogoProps {
    size: MewsLogoSize;
}

export const EventsLogo = ({ size }: ProductLogoProps) => {
    const theme = useTheme();
    const backgroundColor = getToken('backgroundBrand')({ theme });

    return (
        <ProductLogoSvg
            width="58"
            height="20"
            viewBox="0 0 58 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
            size={size}
            role="img"
            aria-label="events-logo"
        >
            <title id="events-logo">Events logo</title>
            <rect
                x="1.36987"
                y="0.75"
                width="55.1876"
                height="18.5"
                rx="7.25"
                stroke={getToken('borderBrand')({ theme })}
                strokeWidth="1.5"
            />
            <path
                d="M43.5303 12.5531C44.1908 13.5072 45.2813 14 46.4661 14C48.1646 14 49.3075 13.0144 49.3075 11.6409C49.3075 10.6553 48.7413 10.0786 47.9864 9.71166C47.669 9.55299 47.2595 9.38279 46.8949 9.23129L46.8948 9.23126L46.8948 9.23124L46.8947 9.23123L46.8947 9.23121C46.6571 9.13248 46.4387 9.0417 46.2773 8.96723C45.9628 8.80996 45.6482 8.58978 45.6482 8.20184C45.6482 7.76147 46.0257 7.45741 46.6443 7.45741C47.179 7.45741 47.8815 7.69856 48.3429 8.18086L49.1712 7.04849C48.4477 6.31455 47.525 6 46.6233 6C45.0506 6 43.9811 6.98558 43.9811 8.26474C43.9811 9.22936 44.5263 9.80603 45.2079 10.194C45.538 10.3781 45.9028 10.5199 46.2486 10.6544C46.4739 10.742 46.6911 10.8265 46.8855 10.9174C47.2839 11.1062 47.5879 11.3368 47.5879 11.7248C47.5879 12.2071 47.1266 12.5531 46.4765 12.5531C45.6902 12.5531 44.9353 12.1756 44.4215 11.4731L43.5303 12.5531ZM37.2935 7.62508H39.5058V13.8741H41.0785V7.62508H43.2908V6.12573H37.2935V7.62508ZM34.7566 6.12573H36.2874V13.8741H35.2284L31.2127 9.12442V13.8741H29.6819V6.12573H30.6675L34.7566 10.9173V6.12573ZM23.006 6.12573V13.8741H28.2589V12.4272H24.5682V10.6867H27.9863V9.23976H24.5682V7.57265H28.2589V6.12573H23.006ZM20.3188 6.12573H22.0803L18.9034 13.8741H17.6661L14.4473 6.12573H16.2402L18.2847 11.4835L20.3188 6.12573ZM8.61987 6.12573V13.8741H13.8728V12.4272H10.1821V10.6867H13.6002V9.23976H10.1821V7.57265H13.8728V6.12573H8.61987Z"
                fill={backgroundColor}
            />
        </ProductLogoSvg>
    );
};

export const FiscalDataModuleLogo = ({ size }: ProductLogoProps) => {
    const theme = useTheme();
    const backgroundColor = getToken('backgroundBrand')({ theme });

    return (
        <ProductLogoSvg
            width="41"
            height="20"
            viewBox="0 0 41 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
            size={size}
            role="img"
            aria-label="fdm-logo"
        >
            <title id="fdm-logo">Fiscal Data Module logo</title>
            <rect
                x="1.70483"
                y="0.75"
                width="38.5177"
                height="18.5"
                rx="7.25"
                stroke={getToken('borderBrand')({ theme })}
                strokeWidth="1.5"
            />
            <path
                d="M24.4475 14.0645V5.93555H25.5255L28.7155 10.5445L31.8725 5.93555H32.9725V14.0645H31.3445V9.45555L28.9795 12.8545H28.4185L26.0535 9.45555V14.0645H24.4475Z"
                fill={backgroundColor}
            />
            <path
                d="M15.7825 14.0645V5.93555H18.9615C21.4145 5.93555 22.8775 7.50855 22.8775 10.0165C22.8775 12.5025 21.3925 14.0645 18.8955 14.0645H15.7825ZM17.4105 12.5025H18.9725C20.4355 12.5025 21.1835 11.3585 21.1835 9.98355C21.1835 8.63055 20.4355 7.49755 18.9725 7.49755H17.4105V12.5025Z"
                fill={backgroundColor}
            />
            <path
                d="M8.95483 14.0645V5.93555H14.3778V7.47555H10.5828V9.30155H13.9158V10.8305H10.5828V14.0645H8.95483Z"
                fill={backgroundColor}
            />
        </ProductLogoSvg>
    );
};

export const KitchenDisplaySystemLogo = ({ size }: ProductLogoProps) => {
    const theme = useTheme();
    const backgroundColor = getToken('backgroundBrand')({ theme });

    return (
        <ProductLogoSvg
            width="38"
            height="20"
            viewBox="0 0 38 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            size={size}
            preserveAspectRatio="xMidYMid meet"
            role="img"
            aria-label="kds-logo"
        >
            <title id="kds-logo">Kitchen Display System logo</title>
            <rect
                x="0.805176"
                y="0.75"
                width="36.3169"
                height="18.5"
                rx="7.25"
                stroke={getToken('borderBrand')({ theme })}
                strokeWidth="1.5"
            />
            <path
                d="M26.891 14.1965C25.648 14.1965 24.504 13.6795 23.811 12.6785L24.746 11.5455C25.285 12.2825 26.077 12.6785 26.902 12.6785C27.584 12.6785 28.068 12.3155 28.068 11.8095C28.068 11.4025 27.749 11.1605 27.331 10.9625C26.814 10.7205 26.143 10.5225 25.571 10.2035C24.856 9.79647 24.284 9.19147 24.284 8.17947C24.284 6.83747 25.406 5.80347 27.056 5.80347C28.002 5.80347 28.97 6.13347 29.729 6.90347L28.86 8.09147C28.376 7.58547 27.639 7.33247 27.078 7.33247C26.429 7.33247 26.033 7.65147 26.033 8.11347C26.033 8.52047 26.363 8.75147 26.693 8.91647C27.122 9.11447 27.936 9.42247 28.486 9.69747C29.278 10.0825 29.872 10.6875 29.872 11.7215C29.872 13.1625 28.673 14.1965 26.891 14.1965Z"
                fill={backgroundColor}
            />
            <path
                d="M15.9141 14.0644V5.93542H19.0931C21.5461 5.93542 23.0091 7.50842 23.0091 10.0164C23.0091 12.5024 21.5241 14.0644 19.0271 14.0644H15.9141ZM17.5421 12.5024H19.1041C20.5671 12.5024 21.3151 11.3584 21.3151 9.98342C21.3151 8.63042 20.5671 7.49743 19.1041 7.49743H17.5421V12.5024Z"
                fill={backgroundColor}
            />
            <path
                d="M12.9392 14.0644L10.6842 10.8414L9.68318 12.0404V14.0644H8.05518V5.93542H9.68318V9.77443L12.7632 5.93542H14.7322L11.7512 9.63142L14.9412 14.0644H12.9392Z"
                fill={backgroundColor}
            />
        </ProductLogoSvg>
    );
};

export const MultiPropertyLogo = ({ size }: ProductLogoProps) => {
    const theme = useTheme();
    const backgroundColor = getToken('backgroundBrand')({ theme });

    return (
        <ProductLogoSvg
            width="32"
            height="20"
            viewBox="0 0 32 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            size={size}
            preserveAspectRatio="xMidYMid meet"
            role="img"
            aria-label="mp-logo"
        >
            <title id="mp-logo">Multi Property logo</title>
            <rect
                x="0.893555"
                y="0.75"
                width="30.1399"
                height="18.5"
                rx="7.25"
                stroke={getToken('borderBrand')({ theme })}
                strokeWidth="1.5"
            />
            <path
                d="M21.047 6.12585C22.9972 6.12585 23.7835 7.39453 23.7835 8.68418C23.7835 10.0053 22.9552 11.2006 20.9316 11.2006H19.7363V13.8742H18.1846V6.12585H21.047ZM20.984 9.79558C21.8333 9.79558 22.2003 9.22939 22.2003 8.66321C22.2003 8.08654 21.8019 7.56229 21.0679 7.56229H19.7363V9.79558H20.984Z"
                fill={backgroundColor}
            />
            <path
                d="M8.14355 13.8742V6.12585H9.17108L12.2117 10.519L15.2209 6.12585H16.2694V13.8742H14.7176V9.48103L12.4633 12.7209H11.9286L9.67435 9.48103V13.8742H8.14355Z"
                fill={backgroundColor}
            />
        </ProductLogoSvg>
    );
};

export const PropertyManagementSystemLogo = ({ size }: ProductLogoProps) => {
    const theme = useTheme();
    const backgroundColor = getToken('backgroundBrand')({ theme });

    return (
        <ProductLogoSvg
            width="38"
            height="20"
            viewBox="0 0 38 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            size={size}
            preserveAspectRatio="xMidYMid meet"
            role="img"
            aria-label="pms-logo"
        >
            <title id="pms-logo">Property Management System logo</title>
            <rect
                x="0.75"
                y="0.75"
                width="36.4271"
                height="18.5"
                rx="7.25"
                stroke={getToken('borderBrand')({ theme })}
                strokeWidth="1.5"
            />
            <path
                d="M27.0857 14C25.9009 14 24.8105 13.5072 24.1499 12.5531L25.0411 11.4731C25.5549 12.1756 26.3098 12.5531 27.0962 12.5531C27.7462 12.5531 28.2076 12.2071 28.2076 11.7248C28.2076 11.3368 27.9035 11.1062 27.5051 10.9174C27.0123 10.6868 26.3727 10.498 25.8275 10.194C25.146 9.80603 24.6008 9.22936 24.6008 8.26474C24.6008 6.98558 25.6702 6 27.243 6C28.1447 6 29.0673 6.31455 29.7908 7.04849L28.9625 8.18086C28.5011 7.69856 27.7987 7.4574 27.2639 7.4574C26.6453 7.4574 26.2679 7.76147 26.2679 8.20184C26.2679 8.58978 26.5824 8.80996 26.897 8.96723C27.3059 9.15596 28.0818 9.44954 28.606 9.71166C29.3609 10.0786 29.9271 10.6553 29.9271 11.6409C29.9271 13.0144 28.7842 14 27.0857 14Z"
                fill={backgroundColor}
            />
            <path
                d="M14.8284 13.8741V6.12573H15.8559L18.8965 10.5189L21.9057 6.12573H22.9542V13.8741H21.4024V9.48091L19.1482 12.7208H18.6134L16.3592 9.48091V13.8741H14.8284Z"
                fill={backgroundColor}
            />
            <path
                d="M10.8624 6.12573C12.8126 6.12573 13.599 7.39441 13.599 8.68405C13.599 10.0052 12.7706 11.2004 10.7471 11.2004H9.55177V13.8741H8V6.12573H10.8624ZM10.7995 9.79546C11.6488 9.79546 12.0157 9.22927 12.0157 8.66308C12.0157 8.08641 11.6173 7.56217 10.8834 7.56217H9.55177V9.79546H10.7995Z"
                fill={backgroundColor}
            />
        </ProductLogoSvg>
    );
};

export const PointOfSaleLogo = ({ size }: ProductLogoProps) => {
    const theme = useTheme();
    const backgroundColor = getToken('backgroundBrand')({ theme });

    return (
        <ProductLogoSvg
            width="38"
            height="20"
            viewBox="0 0 38 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            size={size}
            preserveAspectRatio="xMidYMid meet"
            role="img"
            aria-label="pos-logo"
        >
            <title id="pos-logo">Point of Sale logo</title>
            <rect
                x="1.28076"
                y="0.75"
                width="35.3656"
                height="18.5"
                rx="7.25"
                stroke={getToken('borderBrand')({ theme })}
                strokeWidth="1.5"
            />
            <path
                d="M26.5586 14C25.3754 14 24.2864 13.5079 23.6267 12.555L24.5168 11.4765C25.0298 12.178 25.7838 12.555 26.5691 12.555C27.2183 12.555 27.6791 12.2095 27.6791 11.7278C27.6791 11.3403 27.3754 11.11 26.9775 10.9215C26.4853 10.6911 25.8466 10.5026 25.3021 10.199C24.6215 9.81155 24.077 9.23563 24.077 8.27228C24.077 6.99479 25.145 6.0105 26.7157 6.0105C27.6162 6.0105 28.5377 6.32463 29.2602 7.05762L28.433 8.18851C27.9723 7.70683 27.2707 7.466 26.7367 7.466C26.1189 7.466 25.7419 7.76966 25.7419 8.20945C25.7419 8.59689 26.056 8.81678 26.3702 8.97385C26.7785 9.16233 27.5534 9.45552 28.077 9.7173C28.8309 10.0838 29.3963 10.6597 29.3963 11.644C29.3963 13.0157 28.255 14 26.5586 14Z"
                fill={backgroundColor}
            />
            <path
                d="M18.9208 14C16.6172 14 14.8999 12.2513 14.8999 10.0314C14.8999 7.7801 16.6695 6 18.9313 6C21.1931 6 22.9627 7.79058 22.9627 10.0105C22.9627 12.2199 21.214 14 18.9208 14ZM18.9313 12.4712C20.2926 12.4712 21.3606 11.4241 21.3502 10.0105C21.3502 8.56544 20.2612 7.5288 18.9313 7.5288C17.591 7.5288 16.5125 8.58639 16.5125 10.0105C16.5125 11.4241 17.5701 12.4712 18.9313 12.4712Z"
                fill={backgroundColor}
            />
            <path
                d="M11.3894 6.13599C13.337 6.13599 14.1224 7.403 14.1224 8.69096C14.1224 10.0103 13.2952 11.204 11.2742 11.204H10.0805V13.8742H8.53076V6.13599H11.3894ZM11.3266 9.80091C12.1747 9.80091 12.5412 9.23546 12.5412 8.67002C12.5412 8.0941 12.1433 7.57054 11.4103 7.57054H10.0805V9.80091H11.3266Z"
                fill={backgroundColor}
            />
        </ProductLogoSvg>
    );
};
